/* eslint-disable no-loop-func */
import React, { Component } from 'react';

import API from '../../../../utils/API';
import { Modal, ModalBody } from 'reactstrap';

import Dropzone from 'react-dropzone';
import papa from 'papaparse';
import moment from 'moment';
import SelectField from '../../../../components/inputs/selectField';
import LoadingWizard from '../../../../components/spinner/wizard';
import { FixedSizeList as List } from 'react-window';

const UNMAPPED_DATA = 'Unmapped Data';

const KEY_COLUMN_OPTIONS = [
    { value: null, label: 'None — add only (no matching)' },
    { value: 'name', label: 'Name' },
    { value: 'referenceNumber', label: 'Reference Number' },
    { value: 'vendor', label: 'Vendor' },
    { value: 'trackingNumber', label: 'Tracking Number' },
];

const FIELD_LABELS = {
    name: 'Name',
    category: 'Category',
    referenceNumber: 'Reference Number',
    vendor: 'Vendor',
    status: 'Status',
    trackingNumber: 'Tracking Number',
    arrivalDate: 'Arrival Date',
    postEventPlan: 'Post Event Plan',
    quantity: 'Quantity',
    price: 'Price',
};

class ImportInventoryModal extends Component {
    constructor(props) {
        super(props);
        const unmappedData = {};
        unmappedData[UNMAPPED_DATA] = {};

        this.networkControllers = [];
        this.state = {
            files: [],
            customFields: [
                {
                    title: 'General Information',
                    _id: 0,
                    fields: [
                        { fieldName: 'Name', fieldType: 'text', _id: 'name' },
                        { fieldName: 'Category', fieldType: 'text', _id: 'category' },
                        { fieldName: 'Reference Number', fieldType: 'text', _id: 'referenceNumber' },
                        { fieldName: 'Vendor', fieldType: 'text', _id: 'vendor' },
                        { fieldName: 'Status', fieldType: 'text', _id: 'status' },
                        { fieldName: 'Tracking Number', fieldType: 'text', _id: 'trackingNumber' },
                        { fieldName: 'Arrival Date', fieldType: 'date', _id: 'arrivalDate' },
                        { fieldName: 'Post Event Plan', fieldType: 'text', _id: 'postEventPlan' },
                        { fieldName: 'Quantity', fieldType: 'number', _id: 'quantity' },
                        { fieldName: 'Price', fieldType: 'number', _id: 'price' },
                    ]
                }
            ],
            submitting: false,
            // Step flags
            showKeySelect: false,
            mapping: false,
            showConfirm: false,
            importedStarted: false,

            mappedData: {},
            unmappedData: unmappedData,
            fieldOptions: [],
            importedInventory: [],
            finished: false,
            importCount: 0,
            importLength: 0,
            nameExists: false,
            filteredInventory: [],
            importError: false,
            errorCount: 0,
            isError: false,
            cancelled: false,
            validating: false,
            duplicateFieldNames: {},

            keyColumn: null,
            confirmToInsert: [],
            confirmToUpdate: [],
        };
    }

    componentDidMount() {
        const { duplicateFieldNames, customFields } = this.state;
        customFields.forEach(category => {
            category.fields.forEach(field => {
                const fieldName = field.fieldName;
                if (!duplicateFieldNames[fieldName]) {
                    duplicateFieldNames[fieldName] = 1;
                } else {
                    duplicateFieldNames[fieldName]++;
                }
            });
        });
    }

    downloadCSVTemplate = () => {
        const mappedFieldNames = [];
        this.state.customFields.forEach((category) => {
            category.fields.forEach((field) => {
                mappedFieldNames.push(field.fieldName);
            });
        });
        const csv = papa.unparse([mappedFieldNames]);
        const filename = `InventoryImportTemplate.csv`;
        var file = new Blob([csv], { type: 'text/csv' });
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(file, filename);
        } else {
            var a = document.createElement('a'),
                url = URL.createObjectURL(file);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(function () {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 0);
        }
    };

    handleKeyColumnConfirm = () => {
        this.setState({ showKeySelect: false, mapping: true });
    };

    handleImport = () => {
        const { mappedData } = this.state;
        const inventoryItems = [];

        Object.keys(mappedData).forEach((category) => {
            if (mappedData[category]._id === 0) {
                Object.keys(mappedData[category]).forEach((field) => {
                    if (field !== '_id') {
                        const data = mappedData[category][field];
                        data.forEach((value, index) => {
                            if (index > 0) {
                                if (!inventoryItems[index]) {
                                    inventoryItems[index] = {};
                                }
                                inventoryItems[index][data[0].value] = value;
                                inventoryItems[index]['rowNumber'] = index + 1;
                            }
                        });
                    }
                });
            }
        });

        const filteredInventory = inventoryItems.filter((item) => item && item.name && item.name !== '');

        this.setState(
            { submitting: true, mapping: false, importLength: filteredInventory.length, filteredInventory },
            () => { this.validateData(); }
        );
    };

    validateData = async () => {
        const { mappedData, keyColumn } = this.state;
        let nameExists = false;
        const filtered = this.state.filteredInventory;
        this.setState({ validating: true });

        if (mappedData['General Information'] && mappedData['General Information']['Name']) {
            nameExists = true;
        }

        const isError = !nameExists;

        this.setState({
            nameExists,
            filteredInventory: filtered,
            importLength: filtered.length,
            submitting: false,
            validating: false,
            isError
        }, () => {
            if (!isError) {
                if (keyColumn) {
                    this.buildConfirmationData();
                } else {
                    this.uploadInventory(this.state.filteredInventory);
                }
            }
        });
    };

    buildConfirmationData = () => {
        const { filteredInventory, keyColumn } = this.state;
        const existingInventory = this.props.existingInventory || [];
        const toInsert = [];
        const toUpdate = [];

        filteredInventory.forEach(item => {
            const keyVal = item[keyColumn];
            const existing = keyVal
                ? existingInventory.find(
                    e => e[keyColumn] != null &&
                        e[keyColumn].toString().toLowerCase() === keyVal.toString().toLowerCase()
                )
                : null;

            if (existing) {
                const changes = [];
                Object.keys(item).forEach(field => {
                    if (field === 'rowNumber') return;
                    const oldVal = existing[field];
                    const newVal = item[field];
                    if (newVal !== undefined && newVal !== '' && newVal !== null &&
                        String(newVal) !== String(oldVal)) {
                        changes.push({
                            field,
                            label: FIELD_LABELS[field] || field,
                            oldVal: oldVal != null ? oldVal : '—',
                            newVal
                        });
                    }
                });
                toUpdate.push({ item, existing, changes });
            } else {
                toInsert.push(item);
            }
        });

        this.setState({ confirmToInsert: toInsert, confirmToUpdate: toUpdate, showConfirm: true });
    };

    handleConfirmImport = () => {
        this.setState({ showConfirm: false }, () => {
            this.uploadInventory(this.state.filteredInventory);
        });
    };

    uploadInventory = async (inventory) => {
        const { eventId, orgId } = this.props;
        const { keyColumn } = this.state;
        this.setState({ importedStarted: true, submitting: true });

        const chunkSize = 10000;
        const inventoryChunks = [];
        const chunkCount = Math.ceil(inventory.length / chunkSize);

        for (let i = 0; i < chunkCount; i++) {
            inventoryChunks.push(inventory.slice(i * chunkSize, (i + 1) * chunkSize));
        }

        for (let i = 0; i < chunkCount; i++) {
            if (this.state.cancelled) break;
            await API()
                .post(`Organizations/${orgId}/events/${eventId}/batchInventory`, {
                    inventoryList: inventoryChunks[i],
                    ...(keyColumn ? { keyColumn } : {})
                })
                .then((res) => {
                    const { importedInventory } = this.state;
                    if (res.data) {
                        this.setState({
                            importCount: this.state.importCount + res.data.length,
                            importedInventory: [...importedInventory, ...res.data.map(inv => ({ ...inv, success: true }))]
                        });
                    }
                    this.props.addImportedInventory(res.data, !!keyColumn);
                })
                .catch((e) => { console.log(e); });

            if (i === chunkCount - 1) {
                this.setState({ finished: true });
            }
        }
    };

    isRequiredMapped = () => {
        const { mappedData } = this.state;
        if (mappedData['General Information']) {
            this.setState({ nameExists: !!mappedData['General Information']['Name'] });
        }
    };

    onDrop = (files) => {
        papa.parse(files[0], {
            complete: (res) => {
                try {
                    const trimmedData = res.data.filter(subArray => {
                        let isEmptyRow = true;
                        subArray.forEach(data => { if (data.trim() !== '') isEmptyRow = false; });
                        return !isEmptyRow;
                    });

                    const data = this.mapData(trimmedData);
                    const fieldData = this.state.customFields.map((category) => {
                        const title = category.title;
                        const headers = category.fields.map((header) => ({
                            _id: header._id,
                            category: title,
                            categoryId: category._id,
                            value: header.fieldName,
                            label: header.fieldName
                        }));
                        return { label: title, value: category._id, options: headers };
                    });

                    this.isRequiredMapped();
                    this.setState({
                        showKeySelect: true,
                        mapping: false,
                        mappedData: data.mappedData,
                        unmappedData: data.unmappedData,
                        fieldOptions: fieldData
                    });
                } catch (e) {
                    console.log(e);
                    this.setState({ importError: true });
                }
            }
        });
        this.setState({ files });
    };

    mapData = (csvData) => {
        const { customFields, duplicateFieldNames } = this.state;
        const csvHeaders = csvData[0];
        const mappedData = {};
        let usedFields = [];

        customFields.forEach((category) => {
            const categoryTitle = category.title;
            mappedData[categoryTitle] = {};
            mappedData[categoryTitle]._id = category._id;
            category.fields.forEach((field) => {
                const fieldName = field.fieldName;
                if (!usedFields.includes(fieldName)) {
                    mappedData[categoryTitle][fieldName] = [{ label: fieldName, value: field._id }];
                    let count = -1;
                    const headerIndex = csvHeaders.findIndex((csvHeader) => {
                        count++;
                        if (csvHeader.toLowerCase() === fieldName.toLowerCase()) {
                            if (duplicateFieldNames && duplicateFieldNames[fieldName] > 1) return false;
                            if (!usedFields.find((o) => o.fieldName === fieldName && o.index === count)) {
                                usedFields.push({ fieldName: fieldName, index: count });
                                return true;
                            }
                        }
                        return false;
                    });
                    if (headerIndex > -1) {
                        mappedData[categoryTitle][fieldName][0].headerIndex = headerIndex;
                        csvData.forEach((row, index) => {
                            if (index > 0) {
                                let value = null;
                                switch (field.fieldType) {
                                    case 'number':
                                        value = Number.parseFloat(row[headerIndex]);
                                        break;
                                    case 'date':
                                        value = row[headerIndex] ? moment(row[headerIndex]).format('YYYY-MM-DD') : '';
                                        break;
                                    case 'checkbox':
                                        value = row[headerIndex].toLowerCase() === 'yes';
                                        break;
                                    default:
                                        value = row[headerIndex];
                                }
                                mappedData[categoryTitle][fieldName][index] =
                                    typeof value === 'string' ? value.trim() : value;
                            }
                        });
                    }
                    if (mappedData[categoryTitle][fieldName].length < 2) {
                        delete mappedData[categoryTitle][fieldName];
                    }
                }
            });
            if (Object.keys(mappedData[categoryTitle]).length < 2) {
                delete mappedData[categoryTitle];
            }
        });

        const unmappedData = {};
        unmappedData[UNMAPPED_DATA] = {};
        csvHeaders.forEach((header, headerIndex) => {
            if (!usedFields.find((f) => f.fieldName === header && f.index === headerIndex)) {
                unmappedData[UNMAPPED_DATA][header.concat('-', headerIndex.toString())] = [
                    { label: header, value: header, headerIndex: headerIndex }
                ];
                csvData.forEach((row, index) => {
                    if (index > 0) {
                        unmappedData[UNMAPPED_DATA][header.concat('-', headerIndex.toString())][index] = row[headerIndex];
                    }
                });
            }
        });

        if (mappedData['General Information']) {
            this.setState({ nameExists: Object.keys(mappedData['General Information']).includes('Name') });
        } else {
            this.setState({ nameExists: false });
        }

        return { mappedData, unmappedData };
    };

    FieldContainer = (category, header, columnData, index, isUnmapped) => {
        const selectedOption = { value: header, label: header };
        const dataPreview = JSON.parse(JSON.stringify(columnData));
        let data = '';
        for (let dataCount = 1; dataCount < dataPreview.length; dataCount++) {
            if (dataPreview[dataCount]) { data = dataPreview[dataCount]; break; }
        }
        return (
            <div className="w-100 mb-20" key={index}>
                <div className='flex aic jcsb'>
                    <div className='flex w-100'>
                        <div style={{ width: 21 }} />
                        <div
                            className='w-100'
                            style={{
                                maxWidth: 283, minWidth: 283, width: 283,
                                border: isUnmapped ? `1px solid var(--danger)` : `1px solid var(--border)`,
                                borderRadius: 5, padding: '3px 17px', height: 40
                            }}>
                            <p>{columnData[0].label}</p>
                            <p style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                className='small grey'>Ex: {data ? data : 'Blank column'}</p>
                        </div>
                    </div>
                    <i className="las la-arrow-right mr-5 ml-5"
                        style={{ color: category !== UNMAPPED_DATA ? 'var(--primary)' : '' }}
                    />
                    <div className="w-100 mb-a">
                        <SelectField
                            label=""
                            style={{ maxWidth: 283, minWidth: 283, width: 283 }}
                            classes=" neu mb-0 "
                            value={category !== UNMAPPED_DATA && selectedOption}
                            options={this.state.fieldOptions}
                            formatGroupLabel={this.formatGroupLabel}
                            onChange={(data) => {
                                if (category !== UNMAPPED_DATA) {
                                    const mappedData = this.state.mappedData;
                                    columnData[0] = { label: data.label, value: data._id };
                                    if (!mappedData[data.category]) {
                                        mappedData[data.category] = [];
                                        mappedData[data.category][data.label] = columnData;
                                        delete mappedData[category][header];
                                    } else if (!mappedData[data.category][data.label]) {
                                        mappedData[data.category][data.label] = columnData;
                                        delete mappedData[category][header];
                                    }
                                    this.setState({ mappedData }, () => this.isRequiredMapped());
                                } else {
                                    const mappedData = this.state.mappedData;
                                    const unmappedData = this.state.unmappedData;
                                    columnData[0] = { label: columnData[0].label, value: data._id };
                                    if (!mappedData[data.category]) {
                                        mappedData[data.category] = {};
                                        mappedData[data.category]._id = data.categoryId;
                                        mappedData[data.category][data.label] = columnData;
                                        delete unmappedData[category][header];
                                    } else if (!mappedData[data.category][data.label]) {
                                        mappedData[data.category][data.label] = columnData;
                                        delete unmappedData[category][header];
                                    }
                                    this.setState({ mappedData, unmappedData }, () => this.isRequiredMapped());
                                }
                            }}
                            additionalSelectElement={
                                category !== UNMAPPED_DATA ? (
                                    <div
                                        className='c-pointer'
                                        style={{ position: 'absolute', zIndex: 999, right: 30, top: 10 }}
                                        onClick={() => {
                                            const mappedData = this.state.mappedData;
                                            const unmappedData = this.state.unmappedData;
                                            const propertyName = columnData[0].label.concat('-', columnData[0].headerIndex);
                                            if (!unmappedData[UNMAPPED_DATA]) {
                                                unmappedData[UNMAPPED_DATA] = [];
                                                delete mappedData[category][header];
                                                unmappedData[UNMAPPED_DATA][propertyName] = columnData;
                                            } else if (!unmappedData[UNMAPPED_DATA][propertyName]) {
                                                delete mappedData[category][header];
                                                unmappedData[UNMAPPED_DATA][propertyName] = columnData;
                                            } else if (unmappedData[UNMAPPED_DATA][propertyName]) {
                                                delete mappedData[category][header];
                                            }
                                            if (Object.keys(mappedData[category]).length < 2) {
                                                delete mappedData[category];
                                            }
                                            this.setState({ mappedData, unmappedData }, () => this.isRequiredMapped());
                                        }}
                                    >
                                        <i className="lar la-times-circle grey"></i>
                                    </div>
                                ) : null
                            }
                        />
                    </div>
                </div>
            </div>
        );
    };

    cancelImport = async () => {
        this.setState({ cancelled: true });
        this.networkControllers.forEach(async (controller) => {
            try { controller.abort(); } catch (e) { console.log(e); }
        });
    };

    // ── Step body renderers ────────────────────────────────────────────────

    renderUploadStep() {
        return (
            <div className='flex flex-wrap column w-100'>
                <div className='mb-20'>
                    <h4 className='mb-10'>Import inventory data from a spreadsheet to the simple.events workspace.</h4>
                </div>
                <Dropzone
                    accept="text/csv"
                    className="clickable dropzone-details banner mb-10"
                    style={{ height: 375 }}
                    onDrop={this.onDrop.bind(this)}
                >
                    <div>
                        <div className="addIcon"><i className="las la-plus"></i></div>
                        <p className='text-c'>
                            Add inventory CSV File<br />
                            or <span style={{ color: '#2B83F1' }}>Browse</span>
                        </p>
                    </div>
                </Dropzone>
                <div className='mb-40 mt-20'>
                    <h3>Need help getting started?</h3>
                    <p>Make sure the data contains a column for name</p>
                    <p>
                        <span className='click seBlue c-pointer' onClick={this.downloadCSVTemplate}> Download </span> a sample CSV file
                    </p>
                </div>
            </div>
        );
    }

    renderKeySelectStep() {
        const { keyColumn } = this.state;
        const selectedOption = KEY_COLUMN_OPTIONS.find(o => o.value === keyColumn) || KEY_COLUMN_OPTIONS[0];
        return (
            <div className='flex flex-wrap column w-100'>
                <div className='mb-20'>
                    <h4 className='mb-10'>File uploaded successfully. Configure how existing records should be handled.</h4>
                </div>
                <div className='mb-30' style={{ maxWidth: 400 }}>
                    <p className='mb-10' style={{ fontWeight: 600 }}>Match existing records by:</p>
                    <p className='mb-15 small grey'>
                        Choose a field to use as a unique key. If an existing inventory item matches on this
                        field it will be updated with the imported data. Choose <em>None</em> to always create new records.
                    </p>
                    <SelectField
                        label=""
                        classes="neu"
                        value={selectedOption}
                        options={KEY_COLUMN_OPTIONS.map(o => ({ ...o }))}
                        onChange={(opt) => this.setState({ keyColumn: opt.value })}
                    />
                </div>
                {keyColumn && (
                    <div
                        className='mb-20 p-10'
                        style={{ border: '1px solid var(--border)', borderRadius: 5, maxWidth: 400 }}
                    >
                        <p className='small'>
                            <i className='las la-info-circle mr-5' />
                            Existing inventory items will be matched by <strong>{FIELD_LABELS[keyColumn] || keyColumn}</strong>.
                            You will see a preview of all changes before anything is saved.
                        </p>
                    </div>
                )}
            </div>
        );
    }

    renderMappingStep() {
        const { mappedData, unmappedData, nameExists, keyColumn } = this.state;
        const hasUnmappedData = Object.keys(unmappedData[UNMAPPED_DATA]).length > 0;
        let index = 0;
        return (
            <div className={`sectionBody w-100 anim left`} style={{ maxHeight: 400 }}>
                <div className='mb-20'>
                    <h4 className='mb-10'>Map your CSV columns to the relevant inventory fields.</h4>
                    {keyColumn && (
                        <p className='small grey'>
                            <i className='las la-key mr-5' />
                            Matching existing records on: <strong>{FIELD_LABELS[keyColumn] || keyColumn}</strong>
                        </p>
                    )}
                </div>
                <div className='scrollContainer'>
                    {!nameExists && (
                        <p style={{ color: 'red' }}>
                            Name is required and has not been mapped. Please map it before continuing.
                        </p>
                    )}
                    {hasUnmappedData && (
                        <div>
                            <div className='flex mb-10'>
                                <h3 style={{ width: '50%' }}>Unmapped Data</h3>
                                <h3 className='ml-25' style={{ width: '50%' }}>Inventory Column</h3>
                            </div>
                            <div className="importedDataRow">
                                {Object.keys(unmappedData[UNMAPPED_DATA]).map((dataKey) =>
                                    this.FieldContainer(UNMAPPED_DATA, dataKey, unmappedData[UNMAPPED_DATA][dataKey], index++, true)
                                )}
                            </div>
                        </div>
                    )}
                    {Object.keys(mappedData).map((key) => {
                        if (key === '_id') return null;
                        const categoryData = mappedData[key];
                        return (
                            <div key={key}>
                                <div className='flex mb-10'>
                                    <h3 style={{ marginLeft: '20px', width: '50%' }}>{key}</h3>
                                    <h3 className='ml-25' style={{ width: '50%' }}>Inventory Data</h3>
                                </div>
                                <div className="importedDataRow">
                                    {Object.keys(categoryData).map(
                                        (dataKey) =>
                                            dataKey !== '_id' &&
                                            this.FieldContainer(key, dataKey, categoryData[dataKey], index++, hasUnmappedData)
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    renderConfirmStep() {
        const { confirmToInsert, confirmToUpdate, keyColumn, importLength } = this.state;
        const keyLabel = FIELD_LABELS[keyColumn] || keyColumn;
        return (
            <div className={`sectionBody w-100 anim left`}>
                <div className='mb-20'>
                    <h4 className='mb-5'>Review Changes</h4>
                    <p className='small grey'>
                        Matching on <strong>{keyLabel}</strong> &mdash;&nbsp;
                        {confirmToInsert.length} new &nbsp;·&nbsp; {confirmToUpdate.length} to update &nbsp;·&nbsp; {importLength} total
                    </p>
                </div>
                <div className='scrollContainer' style={{ maxHeight: 380 }}>
                    {confirmToUpdate.length > 0 && (
                        <div className='mb-20'>
                            <h3 className='mb-10'>Records to Update ({confirmToUpdate.length})</h3>
                            {confirmToUpdate.map((entry, i) => (
                                <div
                                    key={i}
                                    className='mb-10 p-10'
                                    style={{ border: '1px solid var(--border)', borderRadius: 5 }}
                                >
                                    <p style={{ fontWeight: 600, marginBottom: 6 }}>
                                        {entry.item[keyColumn] || '—'}
                                    </p>
                                    {entry.changes.length === 0 ? (
                                        <p className='small grey'>No changes detected.</p>
                                    ) : (
                                        <div>
                                            {entry.changes.map((change, ci) => (
                                                <p key={ci} className='small mb-5'>
                                                    <span className='grey'>{change.label}:</span>{' '}
                                                    {String(change.oldVal)} <i className='las la-arrow-right' /> <strong>{String(change.newVal)}</strong>
                                                </p>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                    {confirmToInsert.length > 0 && (
                        <div className='mb-20'>
                            <h3 className='mb-10'>New Records to Add ({confirmToInsert.length})</h3>
                            {confirmToInsert.map((item, i) => (
                                <div
                                    key={i}
                                    className='mb-5 p-10'
                                    style={{ border: '1px solid var(--border)', borderRadius: 5 }}
                                >
                                    <p className='small'>{item.name || '—'}</p>
                                </div>
                            ))}
                        </div>
                    )}
                    {confirmToInsert.length === 0 && confirmToUpdate.length === 0 && (
                        <p className='grey text-c mt-20'>No data to import.</p>
                    )}
                </div>
            </div>
        );
    }

    renderProgressStep() {
        const { importedInventory, importLength, errorCount, cancelled, finished, importedStarted } = this.state;
        return (
            <div className="flex column aic pt-20 h-100">
                <h2>
                    {cancelled ? 'Import Stopped' :
                        finished ? 'Importing Complete' :
                            importedStarted ? 'Importing Inventory...' : 'You may Import'}
                </h2>
                {importedStarted && (
                    <p className="mb-20">
                        {(importedInventory.length - errorCount)} of {importLength} inventor{importLength === 1 ? 'y' : 'ies'} imported
                    </p>
                )}
                <div className='sectionBlockAttendees'>
                    <div className='sectionBlock'>
                        <h3 className="pt-20">Imported Inventory</h3>
                        <List height={400} itemCount={importedInventory.length} itemSize={40} width={"100%"}>
                            {({ index, style }) => {
                                const ia = importedInventory[index];
                                return (
                                    <div className="importRow" style={style} key={ia._id}>
                                        <div className='w-100' style={{ maxWidth: '50%', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            {ia.name}
                                        </div>
                                        <div className="statusContainer">
                                            {ia.success ? 'Imported' : ia.error}
                                            {ia.success
                                                ? <i className="las la-check-circle green" />
                                                : <i className="las la-times-circle red" />}
                                        </div>
                                    </div>
                                );
                            }}
                        </List>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { isOpen, toggle } = this.props;
        const {
            submitting, mapping, showKeySelect, showConfirm,
            importedStarted, validating, isError, nameExists,
            finished, cancelled, confirmToInsert, confirmToUpdate
        } = this.state;

        // ── Body step ────────────────────────────────────────────────────────
        let stepContent = null;
        if (importedStarted) {
            stepContent = this.renderProgressStep();
        } else if (showConfirm) {
            stepContent = this.renderConfirmStep();
        } else if (isError) {
            stepContent = (
                <div className={`sectionBody w-100 anim left ml-10`}>
                    <div className='text-c mb-40 mt-20'>
                        <h3 className='mb-10'>Errors found in data</h3>
                        <p className='mb-10'>Please review and make the necessary changes to continue importing.</p>
                    </div>
                </div>
            );
        } else if (mapping) {
            stepContent = this.renderMappingStep();
        } else if (showKeySelect) {
            stepContent = this.renderKeySelectStep();
        } else if (submitting || validating) {
            stepContent = <LoadingWizard text="Processing" loading={true} />;
        } else {
            stepContent = this.renderUploadStep();
        }

        // ── Footer ───────────────────────────────────────────────────────────
        const isUploadStep = !showKeySelect && !mapping && !showConfirm && !importedStarted && !submitting && !validating && !isError;
        const isKeySelectStep = showKeySelect && !mapping;
        const isMappingStep = mapping;
        const isConfirmStep = showConfirm;

        const showBack = isKeySelectStep || isMappingStep;
        const onBack = isMappingStep
            ? () => this.setState({ mapping: false, showKeySelect: true })
            : null;

        let primaryLabel = null;
        let primaryDisabled = false;
        let onPrimary = null;

        if (isKeySelectStep) {
            primaryLabel = 'Continue to Mapping';
            onPrimary = this.handleKeyColumnConfirm;
        } else if (isMappingStep) {
            primaryLabel = this.state.keyColumn ? 'Preview Changes' : 'Import';
            primaryDisabled = !nameExists;
            onPrimary = this.handleImport;
        } else if (isConfirmStep) {
            primaryLabel = 'Confirm & Import';
            primaryDisabled = confirmToInsert.length === 0 && confirmToUpdate.length === 0;
            onPrimary = this.handleConfirmImport;
        }

        return (
            <Modal isOpen={isOpen} toggle={toggle} className="import importModal">
                <div className="modalHeader pb-0">
                    <button onClick={toggle} style={{ position: 'absolute', right: 5, top: 5, padding: 7 }}>
                        <i className='las la-times'></i>
                    </button>
                    <div className="headerContainer">
                        <h1>Import Inventory Data</h1>
                    </div>
                </div>

                <ModalBody className="modalBody">
                    {stepContent}
                </ModalBody>

                <div className="flex mt-20">
                    {showBack && (
                        <button className="neu mr-10" onClick={onBack}>
                            <i className='las la-arrow-left mr-5' /> Back
                        </button>
                    )}
                    <button
                        outline
                        className="neu ml-a mr-15"
                        onClick={importedStarted && !finished ? this.cancelImport : toggle}
                    >
                        {finished || cancelled ? 'Close' : 'Cancel'}
                    </button>
                    {!finished && !isUploadStep && primaryLabel && (
                        <button
                            className={`neu ${primaryDisabled ? 'disabled' : 'prim'}`}
                            disabled={primaryDisabled}
                            onClick={onPrimary}
                        >
                            {primaryLabel}
                        </button>
                    )}
                </div>
            </Modal>
        );
    }
}

export default ImportInventoryModal;
